import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import { usePathname, useSearchParams } from 'next/navigation'

import ButtonLink from 'components/ButtonLink'
import Page from 'components/Page'
import ROUTES from 'config/routes.json'
import content from 'prismic-translates/page-login-to-access.json'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

type Props = {
  classNameRoot?: string
  classNameContent?: string
  isDefaultLoginLink?: boolean
}

export default function LogInToAccess(props: Props) {
  const pathname = usePathname()
  const query = useSearchParams()
  const { classNameRoot, classNameContent, isDefaultLoginLink = false } = props

  return (
    <Page
      rootClassName={classNameRoot || classes.classNameRoot}
      className={classNameContent || classes.classNameContent}
    >
      <div className={classes.root}>
        <div className={classes.content}>
          <h6 className={classes.title} data-testid='please-login-or-register'>
            {t('title')}
          </h6>

          <p className={classes.description}>{t(`${process.env.BRAND_NAME}_text`)}</p>

          <ButtonLink variant='contained' href={ROUTES.REGISTER}>
            {t('register_button')}
          </ButtonLink>

          <ButtonLink
            href={
              isDefaultLoginLink ? ROUTES.LOGIN : `${ROUTES.LOGIN}?from=${encodeURIComponent(`${pathname}?${query}`)}`
            }
            variant='outlined'
          >
            {t('login_button')}
          </ButtonLink>
        </div>
      </div>
    </Page>
  )
}
